export const RADIO: string  = 'radio';
export const LANDING: string  = 'landing';
